import { render, staticRenderFns } from "./BillingInformationsView.vue?vue&type=template&id=5583ddf3"
import script from "./BillingInformationsView.vue?vue&type=script&lang=js"
export * from "./BillingInformationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports